<template>
  <auth-layout>
    <div class="mb-6">
      <h2 class="xl:text-4xl xl:font-light text-2xl font-bold" v-html="title" />
      <p class="mt-2">
        <icon-link :href="route('login')" icon="arrow-thin-left-circle">
          Back to login
        </icon-link>
      </p>
    </div>
    <form @submit.prevent="update">
      <auth-input
        v-model="auth.email"
        label="Email"
        input-type="email"
        :error="getError('email')"
        :required="true"
        placeholder="e.g. your.name@email.com"
        :loading="loading"
        :autocomplete="true"
      />

      <auth-input
        v-model="auth.password"
        label="Password"
        input-type="password"
        :error="getError('password')"
        :required="true"
        placeholder="Your Password"
        :loading="loading"
        :autocomplete="true"
      />

      <auth-input
        v-model="auth.password_confirmation"
        label="Repeat Password"
        input-type="password"
        :required="true"
        :loading="loading"
      />

      <app-button
        type="submit"
        colour="primary"
        class="mt-8 mb-4"
        :disabled="loading"
      >
        <span v-if="!loading">Reset Password</span>
        <span v-else>Reseting...</span>
      </app-button>
    </form>
  </auth-layout>
</template>

<script>
import { requestMixin } from "../mixins/request";
export default {
  name: "Reset",
  ame: "Login",
  mixins: [requestMixin],
  data() {
    return {
      auth: {
        token: this.state.token,
        email: this.state.email,
        autoverify: this.state.autoverify,
        password: "",
        password_confirmation: ""
      },
      loading: false
    };
  },
  computed: {
    title() {
      return this.state.autoverify ? "Complete Registration" : "Reset Password";
    }
  },
  created() {
    document.title = `Password Reset :: ${document.title}`;
  },
  methods: {
    update() {
      this.loading = true;
      return axios
        .post(route("password.update"), this.auth)
        .then(response => this.loginResponse(response))
        .catch(error => this.requestError(error))
        .then(() => (this.loading = false));
    },
    loginResponse() {
      Turbolinks.visit(route("home"));
    }
  }
};
</script>
